module.exports = __webpack_public_path__ + "7c3971d487b737ac37f18271216319eb.svg";